import styled from 'styled-components';
import ColorSF2 from './ColorSF2';

export const Main = styled.div`
  height: 50px;
  width: 100%;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-height: 530px) and (orientation: landscape),
    (max-height: 1024px) and (orientation: portrait) {
    display: ${props => (props.hidden ? 'none' : 'flex')};
  }
`;
export const MenuWrapper = styled.div`
  display: flex;
`;
export const ButtonsWrapper = styled.div`
  margin-left: 10px;
  display: flex;
  height: 100%;
  position: relative;
`;
export const TitleWrapper = styled.div`
  margin: 10px;
  display: flex;
`;
export const ErrorMessage = styled.div`
  margin-left: 10px;
  color: #f00;
  display: flex;
  align-items: center;
`;
export const ButtonWrapper = styled.div`
  margin: 0px 4px;
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  color: ${props =>
    (props.disabled && ColorSF2.lightBlue) || ColorSF2.navyBlue};
  background-color: ${props => props.active && ColorSF2.skyBlue};
`;
export const LogoutIconImage = styled.img`
  height: 20px;
`;
export const CallingRoomsDialogWrapper = styled.div`
  position: absolute;
  right: 118px;
  top: 48px;
  z-index: 1000;
`;
export const BadgeWrapper = styled.div`
  position: absolute;
  left: 40px;
`;
export const DialogBackground = styled.div`
  position: fixed;
  left: 0px;
  top: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
`;

export const style = {
  linkTitle: {
    color: ColorSF2.deepBlack,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  linkLogout: {
    color: ColorSF2.navyBlue,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export const CloseButtonImage = styled.img`
  width: 20px;
  height: 20px;
  margin: 16px;
`;
